import React, { useContext, useEffect, useState } from "react";
// import "./Footer.css";
import social1 from "../../Assets/Images/twitter2.png";
import social2 from "../../Assets/Images/tiktok-icon.png";
import social3 from "../../Assets/Images/linked-in-icon.png";
import social4 from "../../Assets/Images/pinterest-icon.png";
import social5 from "../../Assets/Images/medium-icon.png";
import social7 from "../../Assets/Images/insta-icon.png";
import { Link } from "react-router-dom";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import axios from "axios";
import swal from "sweetalert";

const Footer = () => {
  const { AIuser, AiLogOut } = useContext(UserAuthContext);
  const [allMedia, setAllMedia] = useState({});
  useEffect(() => {
    axios.get(`https://backend.dsl.sg/api/v1/social-link`).then((res) => {
      setAllMedia(res.data);
    });
  }, []);

  const handleOngoingClick = () => {

    swal({
      text: `A customized solution is being developed specifically for your needs. Please check back soon.`,
      icon: "warning",
      button: "OK!",
      className: "modal_class_success",
    });
  }

  return (
    <div className="footer-container">
      <div className="container px-4">
        <div className="row gy-5 g-md-0 g-lg-0 justify-content-between footer-main">
          <div className="col-md-4 col-lg-4 col-12 footer-first-part">
            <div className="d-flex align-items-center">

            </div>

            <h3 style={{ marginBottom: "0px" }}>WHALES AI</h3>

            <div
              style={{ maxWidth: "118px" }}
              className="title-bottom-border"
            ></div>
            <p>
              Meet the world's first AI-based social media marketing manager,
              revolutionizing digital outreach.
            </p>
            <h5>Coming Soon</h5>
            <div
              style={{ maxWidth: "118px" }}
              className="title-bottom-border"
            ></div>
            <div className="className=" col-md-3 col-lg-2 col-12 quick-links-container>

              <p
                onClick={() => {
                  handleOngoingClick();
                }}
                style={{ cursor: "pointer" }}>YouTube News Video AI</p>

              <p
                onClick={() => {
                  handleOngoingClick();
                }}
                style={{ cursor: "pointer" }}>TikTok News Video AI</p>

            </div>
          </div>

          <div className="col-md-3 col-lg-2 col-12 quick-links-container">
            <h3 style={{ marginBottom: "0px" }}>Quick Links</h3>
            <div
              style={{ maxWidth: "118px" }}
              className="title-bottom-border"
            ></div>

            <Link to={`${AIuser ? "/ver2/consultant-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>Social Media Consultant</p>
            </Link>

            <Link to={`${AIuser ? "/ver2/text-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>Text AI</p>
            </Link>
            <Link to={`${AIuser ? "/ver2/image-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>Image AI</p>
            </Link>
            <Link to={`${AIuser ? "/ver2/post-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>Post AI</p>
            </Link>
            <Link to={`${AIuser ? "/ver2/text-video-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>Text Video AI</p>
            </Link>
            <Link to={`${AIuser ? "/ver2/comic-video-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>Comic Video AI</p>
            </Link>
            <Link to={`${AIuser ? "/ver2/news-video-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>News Video AI</p>
            </Link>
            <Link to={`${AIuser ? "/voice-ai" : "/sign-in"}`}>
              <p style={{ cursor: "pointer" }}>Voice AI</p>
            </Link>


          </div>

          <div className="col-md-3 col-lg-2 col-12 footer-third-part">
            <h3
              style={{ marginBottom: "0px", width: "100%" }}
              className="text-nowrap"
            >
              Social Media
            </h3>
            <div
              style={{ maxWidth: "80px" }}
              className="title-bottom-border"
            ></div>

            <div
              style={{ gap: "10px" }}
              className="d-flex align-items-center justify-content-center justify-content-md-start"
            >
              <p>

                <a target="_blank" href={allMedia?.instagram}>
                  <img src={social7} alt="image" />
                </a>
              </p>

              <p>

                <a target="_blank" href={allMedia?.twitter}>
                  <img src={social1} alt="image" />
                </a>
              </p>

              <p>
                <a target="_blank" href={allMedia?.linkedin}>
                  <img src={social3} alt="image" />
                </a>
              </p>
              <p>
                <a target="_blank" href={allMedia?.pinterest}>
                  <img src={social4} alt="image" />
                </a>
              </p>
              <p>

                <a target="_blank" href={allMedia?.medium}>
                  <img src={social5} alt="image" />
                </a>
              </p>
            </div>

            <div className="quick-links-container mt-3">
              {" "}
              <Link to="/ver2/about-us">
                <p style={{ cursor: "pointer" }}>About Us</p>
              </Link>
              <Link to="/ver2/contact">
                <p style={{ cursor: "pointer" }}>Contact Us</p>
              </Link>

              <Link
                to="/ver2/termsofuse"
              >
                <p style={{ cursor: "pointer" }}>
                  Terms Of Use
                </p>
              </Link>

              <Link
                to="/ver2/dataprotectionnotice"
              >
                <p style={{ cursor: "pointer" }}>
                  Data Protection Notice
                </p>
              </Link>

            </div>
          </div>
        </div>
        <div>
          <p
            className="copy-right-text"
            style={{
              marginBottom: "0px",
              fontSize: "14px",
              marginTop: "10px",
              paddingTop: "18px",
              borderTop: "1px solid white",
            }}
          >
            © Whalesai.com | All rights reserved 2024.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
